<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  <astral-button class="btn-list-header" variant="primary" type="button" icon="download" labelKey="PRICELIST.IMPORT_SABO.BUTTON" (click)="importSabo()"></astral-button>
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  <astral-button class="btn-list-header" variant="primary" type="button" icon="download" labelKey="PRICELIST.IMPORT_SABO.BUTTON" (click)="importSabo()"></astral-button>
</div>

<app-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="contextMenuDefinition"
  [itemsSource]="itemsSource"
  [preferencesKey]="preferencesKey"
  (rowClick)="onRowClicked($event)"
>
</app-list-view>
